import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tin-tuc/[slug]/page.tsx");
